/**
 * BigToggle – a Swiggy-style switch component for ON/OFF availability controls.
 * Larger visual footprint than the inline Toggle icons. Single source of truth
 * for the merchant + admin inventory pages.
 */
export default function BigToggle({ on, onClick, disabled = false, labelOn = "On", labelOff = "Off", testid }) {
    return (
        <button
            type="button"
            data-testid={testid}
            disabled={disabled}
            onClick={onClick}
            aria-pressed={on}
            className={`inline-flex items-center gap-2 select-none transition disabled:opacity-50`}
        >
            <span
                className={`relative w-14 h-7 rounded-full transition-colors duration-200 ${on ? "bg-emerald-500" : "bg-zinc-300"}`}
            >
                <span
                    className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow transform transition-transform duration-200 ${on ? "translate-x-7" : "translate-x-0"}`}
                />
            </span>
            <span className={`text-xs font-bold uppercase tracking-wider ${on ? "text-emerald-700" : "text-zinc-500"}`}>
                {on ? labelOn : labelOff}
            </span>
        </button>
    );
}
